import { createAuthStore } from "./epox/services";

const [authStore, authActions] = createAuthStore();

export { authStore };

export const useAuthStore = authStore;

export const actions = {
  ...authActions,
};

export function isAuthenticated() {
  return authStore.getState().token !== null;
}

export function isGuest() {
  return !isAuthenticated();
}
